import styled, { css } from 'styled-components';

import * as mixin from '@wconcept/wconcept-ui/styles/mixin';

interface IProps {
  className: string;
  $size?: string | number;
  $weight?: string | number;
  $lineHeight?: string | number;
  $color?: string;
  $align?: string;
  $font?: string;
  $underline?: boolean;
  $del?: boolean;
  $ellipsis?: number;
}

export const Text = styled.span<IProps>`
  font-size: ${({ $size }) =>
    typeof $size === 'number' ? `${mixin.pxToVw(String($size))}` : $size};
  line-height: ${({ $lineHeight }) =>
    typeof $lineHeight === 'number'
      ? `${mixin.pxToVw(String($lineHeight))}`
      : $lineHeight};
  color: ${({ $color }) => $color};
  text-align: ${({ $align }) => $align};
  text-decoration: ${({ $underline, $del }) =>
    !$del && $underline ? 'underline' : undefined};
  font-weight: ${({ $weight }) => $weight};
  font-family: ${({ $font, theme }) => {
    if ($font === 'bold') {
      return theme.fontFamily.bold;
    }
    if ($font === 'semibold') {
      return theme.fontFamily.semibold;
    }
    if ($font === 'medium') {
      return theme.fontFamily.medium;
    }
    if ($font === 'light') {
      return theme.fontFamily.light;
    }
    if ($font === 'regular') {
      return theme.fontFamily.regular;
    }
    return null;
  }};

  ${props => {
    if (props.$ellipsis !== 0) {
      return css`
        ${mixin.ellipsis(props.$ellipsis)}
      `;
    }
    return null;
  }}

  em,strong {
    font-weight: inherit;
  }

  @media ${({ theme }) => theme.media.sm} {
    font-size: ${({ $size }) =>
      typeof $size === 'number' ? `${$size}px` : $size};
    line-height: ${({ $lineHeight }) =>
      typeof $lineHeight === 'number' ? `${$lineHeight}px` : $lineHeight};
  }
`;
